export default __webpack_public_path__ + "static/media/myimage1.19de5a4e.png";